module.exports = __webpack_public_path__ + "static/contact-e6279d25bf8759b9c89e8e504f23bed5.png";